<template>
   <div>
     <v-menu attach offset-y bottom left origin="top right">
          <v-btn icon    flat slot="activator" class="ma-0">
         <svg
            class="svgClose"
             width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          >   
         <path d="M22 10.6793C21.9582 10.26 21.7077 10.0084 21.4154 9.8826L19.5783 9.33753C19.453 9.04403 19.3695 8.75054 19.2025 8.45704L20.1628 6.77989C20.3299 6.44446 20.2881 6.02516 20.0376 5.77359L18.2422 3.97066C17.9916 3.71908 17.5741 3.67716 17.2401 3.84488L15.5282 4.80923C15.2359 4.68345 14.9436 4.51572 14.6514 4.43186L14.1086 2.58701C14.0251 2.25158 13.6493 2 13.3152 2H10.7265C10.3507 2 10.0167 2.25158 9.93319 2.58701L9.3904 4.43186C9.09812 4.55765 8.80585 4.68345 8.51357 4.80923L6.80167 3.84488C6.50939 3.67716 6.05011 3.71908 5.79958 3.97066L4.00418 5.77359C3.75365 6.02516 3.67015 6.44446 3.87891 6.77989L4.83925 8.45704C4.71399 8.75054 4.58873 9.04402 4.46347 9.37945L2.6263 9.92455C2.29228 10.0084 2 10.3857 2 10.7212V13.2788C2 13.6562 2.25052 13.9916 2.6263 14.0755L4.46347 14.6205C4.58873 14.914 4.71399 15.2495 4.83925 15.543L3.87891 17.2202C3.7119 17.5556 3.75365 17.9748 4.00418 18.2264L5.79958 20.0294C6.05011 20.2809 6.46764 20.3229 6.80167 20.1552L8.51357 19.1908C8.80585 19.3166 9.09812 19.4843 9.3904 19.5682L9.93319 21.413C10.0167 21.7485 10.3925 22 10.7265 22H13.3152C13.691 22 14.0251 21.7485 14.1086 21.413L14.6514 19.5682C14.9436 19.4424 15.2359 19.3166 15.5282 19.1908L17.2401 20.1552C17.5324 20.3229 17.9916 20.2809 18.2422 20.0294L20.0376 18.2264C20.2881 17.9748 20.3716 17.5556 20.1628 17.2202L19.2025 15.543C19.3278 15.2495 19.453 14.956 19.5783 14.6625L21.4154 14.1174C21.7495 14.0336 22 13.6562 22 13.3208V10.6793ZM15.737 11.979C15.737 9.92453 14.0251 8.20545 11.9791 8.20545C9.9332 8.20545 8.2213 9.92453 8.2213 11.979C8.2213 14.0336 9.9332 15.7527 11.9791 15.7527C14.0251 15.7527 15.737 14.0336 15.737 11.979Z" stroke="#ADADAD" stroke-miterlimit="10"/>
      </svg>
   
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile class="pl-0" v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" @click="$emit('clicked',item.href)" 
          ripple="ripple" :disabled="item.disabled"  
          :key="index">
            <v-list-tile-action v-if="item.icon">
              <!-- <v-icon>{{ item.icon }}</v-icon> -->
              <v-img contain width="10px" height="20px" :src="item.icon" />
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      </div>
</template>
<script>
  export default {
    data: () => ({
      User: {
          first_name:""
      },
     items: [
      { 
        icon:'',      
        title: 'Run Report',
        href: 'run',
        click: (e) => {
          console.log(e);
        }
      },
      { 
        icon:'',      
        title: 'Download',
        href: 'download',
        click: (e) => {
          console.log(e);
        }
      },
      { 
        icon:'',      
        title: 'Edit Report',
        href: 'edit',
        click: (e) => {
          console.log(e);
        }
      },
      { 
        icon:'',      
        title: 'Delete Report',
        href: 'delete',
        click: (e) => {
          console.log(e);
        }
      }
    ],

    }),
 
  }
</script>